
<div class="hide-for-small-only">
  <app-ebi-header></app-ebi-header>
</div>

<app-header></app-header>
<section id="main-content-area" role="main">
  <router-outlet></router-outlet>
</section>

<app-footer></app-footer>

@if (useNewFooter) {
  <vf-ebi-footer></vf-ebi-footer>
} @else {
  <div class="hide-for-large hide-for-medium">
    <app-ebi-header></app-ebi-header>
  </div>

  <div class="hide-for-small-only">
    <app-ebi-footer></app-ebi-footer>
  </div>
}

